module.exports = __webpack_public_path__ + "c50f82d71e00844adba1243e61e6775c.png";


//////////////////
// WEBPACK FOOTER
// ./Res/3rd/uandesign/img/empty_img.png
// module id = 2593
// module chunks = 1